<template>
  <div class="homePage">
    <template v-for="(item,index) in navData">
      <div v-show="isLogined">
        <div v-if="!item.desc"><h2>{{item.title}}</h2></div>
        <div v-else>
          <el-tooltip class="item" effect="dark" :content="item.desc" placement="top-start">
            <h2>{{item.title}}</h2>
          </el-tooltip>
        </div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(iData,i) in item.data" :key="i"
                  style="margin-bottom: 20px;cursor: pointer;line-height: 50px;">
            <div v-if="!iData.desc" class="grid-content bg-purple" @click="openSite(iData)">{{iData.name}}</div>
            <div v-else>
              <el-tooltip class="item" effect="dark" :content="iData.desc" placement="top-start">
                <div class="grid-content bg-purple" @click="openSite(iData)">{{iData.name}}</div>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
  import {navData} from '../data/navData.js'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        navPass: 'NAV_PASS',
        loginPass: '',
        isLogined: false,
        navData:navData
      }
    },
    mounted() {
      this.checkLogined()
      if (!this.isLogined) {
        this.login()
      }
    },
    methods: {
      login() {
        //密码为：年+月共6位，不足前面补0；例如2022年1月，密码为202201，一个月变动一次，输入自动登入
        this.$prompt('请输入密码', '登入', {
          confirmButtonText: '登入',
          cancelButtonText: '取消',
          inputType: 'password',
          inputErrorMessage: '密码不正确',
          inputValidator: (value) => {
            if (value != this.getNewPass()) {
              return '密码不正确'
            } else {
              console.log('密码正确')
              //登入
              localStorage.setItem(this.navPass, value);
              this.checkLogined()
              location.reload()
            }
          },
        }).then(({value}) => {
          //登入
        }).catch(() => {
          //取消
        });
      },
      checkLogined() {
        let localPass = localStorage.getItem(this.navPass)
        if (localPass && localPass == this.getNewPass()) {
          this.isLogined = true
        } else {
          this.isLogined = false
        }
      },
      getNewPass() {
        let myDate = new Date();
        let myMonth = '0' + (myDate.getMonth() + 1).toString()
        myMonth = myMonth.length > 2 ? myMonth.substring(1) : myMonth;
        return myDate.getFullYear() + myMonth.toString();
      },
      openSite(item) {
        if (item.outSite) {
          if (item.url != '#')
            window.open(item.url)
        } else {
          this.$router.push({name: item.url})
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .homePage {
    width: 1200px;
    margin: 0 auto;
  }

  .bg-purple {
    background: #ffffff;
    box-shadow: 0px 2px 10px #dfdfdf;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue